import { render, staticRenderFns } from "./Orderbook.vue?vue&type=template&id=52ce8253&scoped=true&"
import script from "./Orderbook.vue?vue&type=script&lang=js&"
export * from "./Orderbook.vue?vue&type=script&lang=js&"
import style0 from "./Orderbook.vue?vue&type=style&index=0&id=52ce8253&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce8253",
  null
  
)

export default component.exports